module.exports = __webpack_public_path__ + "static/media/empty-course.a06cb202.svg";